import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.clients.views.ClientDetailView.';
  public static readonly clientInfo = `${Id.prefix}clientInfo`;
  public static readonly provideCompanyName = `${Id.prefix}provideCompanyName`;
  public static readonly providePrimaryContact = `${Id.prefix}providePrimaryContact`;
  public static readonly provideCompanyEmail = `${Id.prefix}provideCompanyEmail`;
  public static readonly provideValidCompanyEmail = `${Id.prefix}provideValidCompanyEmail`;
  public static readonly primaryContact = `${Id.prefix}primaryContact`;
  public static readonly email = `${Id.prefix}email`;
  public static readonly clientDetails = `${Id.prefix}clientDetails`;
  public static readonly clientName = `${Id.prefix}clientName`;
  public static readonly clientPhone = `${Id.prefix}clientPhone`;
  public static readonly clientStatus = `${Id.prefix}clientStatus`;
  public static readonly physicalAddress = `${Id.prefix}physicalAddress`;
  public static readonly billingAddress = `${Id.prefix}billingAddress`;
  public static readonly clientStateActive = `${Id.prefix}clientStateActive`;
  public static readonly clientStateArchived = `${Id.prefix}clientStateArchived`;
}

export class LangClientDetailView {
  private constructor() {}
  public static clientInfo(): string {
    return interpolate(Id.clientInfo);
  }
  public static provideCompanyName(): string {
    return interpolate(Id.provideCompanyName);
  }
  public static providePrimaryContact(): string {
    return interpolate(Id.providePrimaryContact);
  }
  public static provideCompanyEmail(): string {
    return interpolate(Id.provideCompanyEmail);
  }
  public static provideValidCompanyEmail(): string {
    return interpolate(Id.provideValidCompanyEmail);
  }
  public static primaryContact(): string {
    return interpolate(Id.primaryContact);
  }
  public static email(): string {
    return interpolate(Id.email);
  }
  public static clientDetails(): string {
    return interpolate(Id.clientDetails);
  }
  public static clientName(): string {
    return interpolate(Id.clientName);
  }
  public static clientPhone(): string {
    return interpolate(Id.clientPhone);
  }
  public static clientStatus(): string {
    return interpolate(Id.clientStatus);
  }
  public static physicalAddress(): string {
    return interpolate(Id.physicalAddress);
  }
  public static billingAddress(): string {
    return interpolate(Id.billingAddress);
  }
  public static readonly clientState = {
    active: () => interpolate(Id.clientStateActive),
    archived: () => interpolate(Id.clientStateArchived)
  };
}

export class ClientDetailViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.clientInfo, "{{glossary 'client'}} Info", 'Caption for client info section');
    register.add(Id.provideCompanyName, 'Please provide a Client Name', 'Validation for client name');
    register.add(
      Id.providePrimaryContact,
      "Please provide a Primary {{glossary 'contact'}}",
      'Validation for primary contact'
    );
    register.add(Id.provideCompanyEmail, 'Please provide a Contact Email', 'Validation for contact email');
    register.add(
      Id.provideValidCompanyEmail,
      'Please provide a valid Contact Email',
      'Validation for valid contact email'
    );
    register.add(Id.primaryContact, "Primary {{glossary 'contact'}}", 'Label for primary contact');
    register.add(Id.email, 'Email', 'Label for email');
    register.add(Id.clientDetails, "{{glossary 'client'}} Details", 'Heading for client details');
    register.add(Id.clientName, "{{glossary 'client'}} Name", 'Label for client name');
    register.add(Id.clientPhone, "{{glossary 'client'}} Phone", 'Label for client phone');
    register.add(Id.clientStatus, "{{glossary 'client'}} Status", 'Label for client status');
    register.add(Id.physicalAddress, 'Physical Address', 'Section title for physical address');
    register.add(Id.billingAddress, 'Billing Address', 'Section title for billing address');
    register.add(Id.clientStateActive, 'Active', 'Client state: Active');
    register.add(Id.clientStateArchived, 'Archived', 'Client state: Archived');
  }
}
